/* StudioSoie · Bouclier — pays bloqués (géolocalisation Shopify), extensions espionnes, navigateurs automatisés, protection du contenu.
   Réglages : window.SS_SHIELD (snippets/ss-shield.liquid). Les moteurs de recherche et réseaux sociaux ne sont jamais bloqués. */
(function () {
  'use strict';
  var C = window.SS_SHIELD; if (!C) { return; }
  var UA = navigator.userAgent || '';
  var SEARCH = /Googlebot|Storebot-Google|Google-InspectionTool|AdsBot|Mediapartners-Google|bingbot|BingPreview|DuckDuckBot|Applebot|YandexBot|Baiduspider|facebookexternalhit|Facebot|Twitterbot|LinkedInBot|Pinterest|Slackbot|WhatsApp|TelegramBot|Shopify|Lighthouse|Chrome-Lighthouse|GTmetrix|PageSpeed/i;
  if (SEARCH.test(UA) || (window.Shopify && window.Shopify.designMode)) { return; }
  var isMobile = /Mobi|Android|iPhone|iPad/i.test(UA) || (navigator.maxTouchPoints > 1 && window.innerWidth < 900);
  var P = isMobile ? C.mobile : C.desktop;
  var blocked = false;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function block(title, text, keepPage) {
    if (blocked) { return; }
    blocked = true;
    var html = '<div class="ss-shield-overlay" role="alertdialog" aria-labelledby="ss-shield-title"><div class="ss-shield-box"><h1 id="ss-shield-title">' + esc(title) + '</h1>' +
      (text ? '<p>' + esc(text) + '</p>' : '') +
      (C.t.btnLabel && C.t.btnUrl ? '<a href="' + esc(C.t.btnUrl) + '">' + esc(C.t.btnLabel) + '</a>' : '') +
      '<small>' + esc(C.t.brand) + '</small></div></div>';
    try {
      if (keepPage) { var d = document.createElement('div'); d.innerHTML = html; document.body.appendChild(d.firstChild); document.documentElement.style.overflow = 'hidden'; }
      else {
        var css = document.getElementById('ss-shield-css');
        document.body.innerHTML = html;
        if (css) { document.body.appendChild(css); }
        document.documentElement.style.overflow = 'hidden';
      }
    } catch (e) {}
  }

  /* ---- 1. Pays bloqués : géolocalisation Shopify (pas de service tiers) ---- */
  function checkCountry() {
    if (!C.countries || !C.countries.length) { return; }
    var cached = null;
    try { cached = sessionStorage.getItem('ss_geo'); } catch (e) {}
    function decide(cc) {
      cc = String(cc || '').toUpperCase();
      if (cc && C.countries.indexOf(cc) >= 0) { block(C.t.countryTitle, C.t.countryText, true); }
    }
    if (cached) { decide(cached); return; }
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cc = j && j.detected_values && j.detected_values.country && (j.detected_values.country.handle || j.detected_values.country.iso_code);
        if (cc) { try { sessionStorage.setItem('ss_geo', cc); } catch (e) {} decide(cc); }
      }).catch(function () {});
  }

  /* ---- 2. Extensions espionnes : marqueurs injectés dans la page ---- */
  var SPY = ['#ppspy', '[id^="ppspy"]', '[class*="ppspy"]', '#koala-inspector', '[class*="koala-inspector"]', '[id*="koala"]', '#alihunter', '[id*="alihunter"]', '[class*="alihunter"]',
    '#commerce-inspector', '[class*="commerce-inspector"]', '[id*="commerceinspector"]', '#shine-root', '[id*="sellthetrend"]', '[class*="sellthetrend"]', '[id*="nichescraper"]', '#uuspy', '[id*="uuspy"]',
    '[id*="dropship-spy"]', '[class*="dropship-spy"]', '#simplytrends', '[id*="simplytrends"]', '[id*="shopspy"]', '[class*="shopspy"]', '[id*="ecomhunt"]', '[id*="fastspy"]', '[id*="pexda"]', '#adspy', '[id*="minea"]'];
  function spyFound() {
    for (var i = 0; i < SPY.length; i++) { try { if (document.querySelector(SPY[i])) { return true; } } catch (e) {} }
    return false;
  }
  function checkSpy() {
    if (!C.spy) { return; }
    if (spyFound()) { return block(C.t.blockTitle, C.t.spyText, false); }
    var n = 0, iv = setInterval(function () { if (spyFound()) { clearInterval(iv); block(C.t.blockTitle, C.t.spyText, false); } else if (++n > 24) { clearInterval(iv); } }, 2500);
  }

  /* ---- 3. Navigateurs automatisés ---- */
  function isBot() {
    if (navigator.webdriver === true) { return true; }
    if (/HeadlessChrome|PhantomJS|Selenium|puppeteer|playwright|node-fetch|python-requests|scrapy|HttpClient|curl\/|wget\//i.test(UA)) { return true; }
    if (window.callPhantom || window._phantom || window.__nightmare || window.domAutomation || window.__webdriver_evaluate || document.__selenium_unwrapped) { return true; }
    if (C.botsStrict) {
      if (!navigator.languages || navigator.languages.length === 0) { return true; }
      if (/Chrome\//.test(UA) && !/Edg|OPR|Mobile/.test(UA) && !window.chrome) { return true; }
    }
    return false;
  }
  function checkBots() { if (C.bots && isBot()) { block(C.t.blockTitle, C.t.botText, false); } }

  /* ---- 4. Protection du contenu ---- */
  function protect() {
    var root = document.documentElement;
    if (P.img) { root.classList.add('ss-shield-img'); }
    if (P.video) { root.classList.add('ss-shield-video'); document.querySelectorAll('video').forEach(function (v) { try { v.setAttribute('controlsList', 'nodownload'); v.disablePictureInPicture = true; } catch (e) {} }); }
    if (P.text) { root.classList.add('ss-shield-text'); document.addEventListener('copy', function (e) { if (!e.target.closest || !e.target.closest('input, textarea, [contenteditable], .ssc-root, [data-ss-copy]')) { e.preventDefault(); } }); }
    document.addEventListener('contextmenu', function (e) {
      var t = e.target;
      if (t.closest && t.closest('input, textarea, [contenteditable]')) { return; }
      if (P.rightClick) { e.preventDefault(); return; }
      if (P.img && t.closest && t.closest('img, picture, svg, [style*="background-image"]')) { e.preventDefault(); return; }
      if (P.video && t.closest && t.closest('video')) { e.preventDefault(); }
    });
    if (P.img) { document.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest('img, picture, a')) { e.preventDefault(); } }); }
    if (P.shortcuts) {
      document.addEventListener('keydown', function (e) {
        var k = (e.key || '').toLowerCase(), mod = e.ctrlKey || e.metaKey;
        if (e.key === 'F12' || (mod && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) || (mod && (k === 'u' || k === 's'))) { e.preventDefault(); }
      });
    }
  }

  function run() { checkBots(); if (blocked) { return; } checkSpy(); checkCountry(); protect(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
